import { CurrencyLocation, CurrencyOptions, DecimalSeparator, RoundingMethod, ThousandsSeparator } from '@empathybroker/ebx-gluon';

export const EUR: CurrencyOptions = {
  currencyLocation: CurrencyLocation.APPEND,
  currencySpacing: true,
  decimalDigits: 2,
  decimalSeparator: DecimalSeparator.COMMA,
  currencySymbol: '€',
  hideDecimalsIfZero: false,
  roundingMethod: RoundingMethod.ROUND,
  thousandsSeparator: ThousandsSeparator.NONE
};
